import { Pipe, PipeTransform } from '@angular/core';

import { QwykFilterRule, queryToColumnFilters } from './table.component';

/**
 * Builds the qwyk-table `filters` Input from a flat server query, for tables
 * whose Search panel and column filters share the same query keys:
 *
 *     <qwyk-table [filters]="query | qwykColumnFilters: cols" ...>
 *
 * Pure, so it only recomputes (and hands the table a new object) when the
 * query or the column list changes.
 */
@Pipe({
    standalone: true,
    name: 'qwykColumnFilters',
})
export class QwykColumnFiltersPipe implements PipeTransform {
    transform(
        query: object | null | undefined,
        columns: { filter?: { field: string; type?: string } | null }[] | null | undefined
    ): Record<string, QwykFilterRule> {
        return queryToColumnFilters(query, columns || []);
    }
}
